



















































































import Vue from 'vue';
import { diffWords, Part } from 'diff';
import { DataTypes } from 'expangine-runtime';
import { TypeSettings } from '../runtime/types/TypeVisuals';
import { Preferences } from './Preference';
import { funcTestDialog, PREF_FULLSCREEN_FUNC_TEST } from './FuncTest';
import { LiveRuntime } from 'expangine-runtime-live';


const getColor = (part: Part): string => part.added ? 'added' : part.removed ? 'removed' : '';

export default Vue.extend({
  data: () => funcTestDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    index(): number {
      return this.func.tests.indexOf(this.test);
    },
    isSaved(): boolean {
      return this.index !== -1;
    },
    buttonText(): string {
      return this.isSaved ? 'Close' : 'Cancel';
    },
    settings(): TypeSettings {
      return this.registry.getTypeSettingsValidFor(this.func.params, this.func.meta)
        ? this.func.meta
        : this.registry.getTypeSettings(this.func.params);
    },
    actual(): any {
      const actual = LiveRuntime.run(this.func.expression, DataTypes.copy(this.test.args));

      return actual === undefined ? null : actual;
    },
    expected(): any {
      return this.test.expected === undefined ? null : this.test.expected;
    },
    passes(): boolean {
      return DataTypes.equals(this.actual, this.test.expected);
    },
    showDiff(): boolean {
      return !this.passes;
    },
    diffString(): string {
      return diffWords(this.expectedString || '', this.actualString || '')
        .map((part: Part) => `<span class="${getColor(part)}">${part.value}</span>`)
        .join('')
      ;
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_FUNC_TEST, this.fullscreen);
    },
    renamed(name: string) {
      this.test.name = name;

      if (this.index === -1) {
        this.func.tests.push(this.test);
      }
    },
    remove() {
      if (this.isSaved) {
        this.func.tests.splice(this.index, 1);
      }
      
      this.close(false);
    },
    validateName(name: string) {
      return !name
        ? 'A test name is required'
        : this.func.tests.some((t) => t.name === name && t !== this.test)
          ? 'A test for this function already exists with this name'
          : '';
    },
    updateExpected() {
      this.test.expected = DataTypes.copy(this.actual);
    },
  },
});
